import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../../../core/shared/material.module';

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './delete-confirmation.component.html',
  styleUrl: './delete-confirmation.component.scss'
})
export class DeleteConfirmationComponent {
  activeModal = inject(NgbActiveModal);
  
  @Input()
  data: {
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
  } = {};
}
